// Route configuration for breadcrumbs and page titles
// Uses i18n keys resolved by TopBar and Breadcrumbs

const routeConfig = {
  '/': { labelKey: 'layout:routes.requests' },
  '/requisites': { labelKey: 'layout:routes.requisites' },
  '/addbalance': { labelKey: 'layout:routes.balance' },
  '/settings': { labelKey: 'layout:routes.settings' },
  '/penalties': { labelKey: 'layout:routes.penalties' },
  '/chartsop': { labelKey: 'layout:routes.charts' },
  '/payouts': { labelKey: 'PayOut' },
  '/news': { labelKey: 'layout:routes.news' },
  '/events': { labelKey: 'layout:routes.events' },
  '/team': { labelKey: 'layout:sidebar.menu.team' },
  '/team/:id': { labelKey: 'layout:sidebar.menu.team' },
  '/team/create': { labelKey: 'layout:sidebar.menu.createTrader' },
  '/withdrawals': { labelKey: 'layout:sidebar.menu.withdrawals' },
  '/deposits': { labelKey: 'layout:sidebar.menu.deposits' },
  '/team-stats': { labelKey: 'layout:sidebar.menu.teamStats' },
  '/bot-setup': { labelKey: 'layout:sidebar.menu.botSetup' },
};

export default routeConfig;
